import EarthMedia from './EarthMedia'

export default EarthMedia
